import 'intersection-observer';
import * as React from "react";
import { Updater, IOWidget, fromJSX } from "widgets-for-react";
import { CMSState, Url } from "../types.gen";

export type DownloadBlockNestedProps = {
  index: number
  title?: React.ReactNode
  intro?: string
  items: DownloadProps[]
}

export type DownloadProps = {
  key?: string
  title: string
  text?: string
  file_url: Url
}

export function DownloadBlockNested(
  props: DownloadBlockNestedProps
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(() => (
        <></>
        // <InView
        //   as="section"
        //   onChange={(inView) => blockInviewHandler('download', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
        //   triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
        //   threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
        //   id={`io-${options && options.key ? options.key : props.index}`}
        //   className={getClassName(options, "block_classname", "container")}
        //   key={options && options.key ? options.key : `block-${props.index}`}
        // >
        //   <div className={getClassName(options, "inner_classname", "py-5")}>

        //     {(props.title || props.intro) && (
        //       <header className={getClassName(options, "header_classname", "")}>
        //         {props.title && <h2 className={getClassName(options, "title_classname", "mb-3")}>{props.title}</h2>}
        //         {props.intro && <p className={getClassName(options, "intro_classname", "")}>{props.intro}</p>}
        //       </header>
        //     )}

        //     <div className={getClassName(options, "content_classname", "")}>
        //       <ul className={getClassName(options, "list_classname", "list-unstyled row mb-0")}>
        //         {props.items.map((link, index) => (
        //           <li className={getClassName(options, "item_classname", "col-md-6")} key={`download-${options && options.key ? options.key : props.index}-${index}`}>
        //             <a
        //               download={true}
        //               target="_blank"
        //               href={link.file_url}
        //               className={getClassName(options, "link_classname", "btn btn-link w-100 text-left border-bottom rounded-0 pl-0")}
        //               onClick={() => window.dataLayer.push({
        //                 event: `event.${sitename}`, category: "Downloads", action: link.title, label: window.location.pathname
        //               })}
        //             > 
        //               <p className={getClassName(options, "link_label_classname", "d-block")}>{link.title}</p>
        //               {link.text && (<p className={getClassName(options, "link_text_classname", "small m-0")}>{link.text}</p>)}
        //               {props.useSVGIcons && (
        //                 <svg className={getClassName(options, "link_icon_classname", "")} aria-hidden="true">
        //                   <use xlinkHref={
        //                     getFileType(link.file_url).includes('pdf')
        //                       ? getClassName(options, "icon_pdf_id", "#icon--file")
        //                       : getFileType(link.file_url).includes('doc')
        //                         ? getClassName(options, "icon_word_id", "#icon--file")
        //                         : getFileType(link.file_url).includes('xls')
        //                           ? getClassName(options, "icon_excel_id", "#icon--file")
        //                             : getFileType(link.file_url).includes('zip') || getFileType(link.file_url).includes('rar')
        //                               ? getClassName(options, "icon_zip_id", "#icon--file")
        //                               : getClassName(options, "icon_file_id", "#icon--file")
        //                   }/>
        //                 </svg>
        //               )}
        //             </a>
        //           </li>
        //         ))}
        //       </ul>
        //     </div>
        //   </div>
        // </InView>
      ),
    )
}
